import React from "react";
import HeroSection from "../Components/Shopify/HeroSection";
import FormSection from "../Components/Shopify/FormSection";
import NavBar from "../Components/NavBar/NavBar2";
export default function ShopifyPage() {
  return (
    <>
      <div className="flex flex-col min-h-screen bg-grey-100 ">
        <NavBar />
        <main className="flex-1">
          <HeroSection />
          {/* <HowItWorksSection />
          <FeatureSection /> */}
          <FormSection />
        </main>
      </div>
    </>
  );
}
